import { useInspectionCarsOperations } from './useInspectionCarsOperations';

export { useInspectionCarsOperations };
